import React from 'react';

const StarRating = ({ rating }) => {
  const fullStars = Math.floor(rating); // Number of full stars
  const hasHalfStar = rating - fullStars >= 0.5; // Whether to display a half star

  // Array of star icons (full, half, or empty)
 const stars = [];
  for (let i = 0; i < fullStars; i++) {
    stars.push(<i className="fa fa-star golden-star" key={i}></i>);
  }
  if (hasHalfStar) {
    stars.push(<i className="fa fa-star-half golden-star" key={fullStars}></i>);
  }
  const emptyStars = 5 - stars.length;
  for (let i = 0; i < emptyStars; i++) {
    stars.push(<i className="fa fa-star-o golden-star" key={fullStars + i + 1}></i>);
  }

  return <p>Rating: {stars}</p>;
};

export default StarRating;
